"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ellipsis = exports.CountInfo = void 0;
exports.Meta = Meta;
exports.RooNode = RooNode;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _value = require("./value");
var _TriangleArrow = require("./arrow/TriangleArrow");
var _store = require("./store");
var _copied = require("./copied");
var _semicolon = require("./semicolon");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isArray", "start", "className", "render"],
  _excluded2 = ["style", "render"],
  _excluded3 = ["value", "keyName", "className", "displayDataTypes", "components", "displayObjectSize", "enableClipboard", "highlightUpdates", "objectSortKeys", "indentWidth", "collapsed", "level", "keyid", "quotes", "onCopied", "onExpand"];
function Meta(props) {
  var _props$isArray = props.isArray,
    isArray = _props$isArray === void 0 ? false : _props$isArray,
    _props$start = props.start,
    start = _props$start === void 0 ? false : _props$start,
    className = props.className,
    render = props.render,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var mark = isArray ? '[]' : '{}';
  var cls = "w-rjv-".concat(isArray ? 'brackets' : 'curlybraces', "-").concat(start ? 'start' : 'end', " ").concat(className || '');
  var color = "var(--w-rjv-".concat(isArray ? 'brackets' : 'curlybraces', "-color, #236a7c)");
  if (render) return render((0, _objectSpread2["default"])({
    isArray: isArray,
    className: cls,
    style: {
      color: color
    },
    children: start ? mark.charAt(0) : mark.charAt(1)
  }, reset));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Label, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    color: color,
    className: cls
  }, reset), {}, {
    children: start ? mark.charAt(0) : mark.charAt(1)
  }));
}
var Ellipsis = function Ellipsis(_ref) {
  var style = _ref.style,
    render = _ref.render,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  var styl = (0, _objectSpread2["default"])({
    cursor: 'pointer'
  }, style);
  var className = "w-rjv-ellipsis ".concat(props.className || '');
  if (render) return render((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    style: styl
  }, props), {}, {
    className: className
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: className,
    style: styl
  }, props), {}, {
    children: "..."
  }));
};
exports.Ellipsis = Ellipsis;
var CountInfo = function CountInfo(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Label, {
    style: {
      paddingLeft: 4,
      fontStyle: 'italic'
    },
    color: "var(--w-rjv-info-color, #0000004d)",
    className: "w-rjv-object-size",
    children: children
  });
};
exports.CountInfo = CountInfo;
function RooNode(props) {
  var _expands$keyid;
  var _props$value = props.value,
    value = _props$value === void 0 ? {} : _props$value,
    keyName = props.keyName,
    className = props.className,
    _props$displayDataTyp = props.displayDataTypes,
    displayDataTypes = _props$displayDataTyp === void 0 ? true : _props$displayDataTyp,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    _props$displayObjectS = props.displayObjectSize,
    displayObjectSize = _props$displayObjectS === void 0 ? true : _props$displayObjectS,
    _props$enableClipboar = props.enableClipboard,
    enableClipboard = _props$enableClipboar === void 0 ? true : _props$enableClipboar,
    _props$highlightUpdat = props.highlightUpdates,
    highlightUpdates = _props$highlightUpdat === void 0 ? true : _props$highlightUpdat,
    _props$objectSortKeys = props.objectSortKeys,
    objectSortKeys = _props$objectSortKeys === void 0 ? false : _props$objectSortKeys,
    _props$indentWidth = props.indentWidth,
    indentWidth = _props$indentWidth === void 0 ? 15 : _props$indentWidth,
    collapsed = props.collapsed,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$keyid = props.keyid,
    keyid = _props$keyid === void 0 ? 'root' : _props$keyid,
    _props$quotes = props.quotes,
    quotes = _props$quotes === void 0 ? '"' : _props$quotes,
    onCopied = props.onCopied,
    onExpand = props.onExpand,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var isArray = Array.isArray(value);
  var subkeyid = (0, _react.useId)();
  var expands = (0, _store.useExpandsStatus)();
  var expand = (_expands$keyid = expands[keyid]) !== null && _expands$keyid !== void 0 ? _expands$keyid : typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level <= collapsed : true;
  var arrowStyle = {
    transform: "rotate(".concat(expand ? '0' : '-90', "deg)"),
    transition: 'all 0.3s'
  };
  var handle = function handle() {
    onExpand && typeof onExpand === 'function' && onExpand({
      expand: !expand,
      keyid: keyid,
      keyName: keyName,
      value: value
    });
    !expand ? _store.store.expand(keyid) : _store.store.collapse(keyid);
  };
  var subNodeProps = {
    components: components,
    indentWidth: indentWidth,
    displayDataTypes: displayDataTypes,
    displayObjectSize: displayObjectSize,
    enableClipboard: enableClipboard,
    highlightUpdates: highlightUpdates,
    onCopied: onCopied,
    onExpand: onExpand,
    collapsed: collapsed,
    quotes: quotes,
    level: level + 1,
    style: {
      paddingLeft: indentWidth
    }
  };
  var valueViewProps = {
    displayDataTypes: displayDataTypes,
    displayObjectSize: displayObjectSize,
    enableClipboard: enableClipboard,
    indentWidth: indentWidth,
    renderBraces: components.braces,
    renderValue: components.value
  };
  var arrowView = components.arrow ? /*#__PURE__*/(0, _react.cloneElement)(components.arrow, {
    style: arrowStyle,
    'data-expand': expand,
    className: "w-rjv-arrow"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TriangleArrow.TriangleArrow, {
    style: arrowStyle,
    className: "w-rjv-arrow"
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showTools = _useState2[0],
    setShowTools = _useState2[1];
  var tools = enableClipboard ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_copied.Copied, {
    show: showTools,
    text: value,
    onCopied: onCopied,
    render: components.copied
  }) : undefined;
  var eventProps = {};
  if (enableClipboard) {
    eventProps.onMouseEnter = function () {
      return setShowTools(true);
    };
    eventProps.onMouseLeave = function () {
      return setShowTools(false);
    };
  }
  var nameKeys = isArray ? Object.keys(value).map(function (m) {
    return Number(m);
  }) : Object.keys(value);

  // object
  var entries = isArray ? Object.entries(value).map(function (m) {
    return [Number(m[0]), m[1]];
  }) : Object.entries(value);
  if (objectSortKeys) {
    entries = objectSortKeys === true ? entries.sort(function (_ref3, _ref4) {
      var _ref5 = (0, _slicedToArray2["default"])(_ref3, 1),
        a = _ref5[0];
      var _ref6 = (0, _slicedToArray2["default"])(_ref4, 1),
        b = _ref6[0];
      return typeof a === 'string' && typeof b === 'string' ? a.localeCompare(b) : 0;
    }) : entries.sort(function (_ref7, _ref8) {
      var _ref9 = (0, _slicedToArray2["default"])(_ref7, 1),
        a = _ref9[0];
      var _ref10 = (0, _slicedToArray2["default"])(_ref8, 1),
        b = _ref10[0];
      return typeof a === 'string' && typeof b === 'string' ? objectSortKeys(a, b) : 0;
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, reset), {}, {
    className: "".concat(className, " w-rjv-inner")
  }, eventProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_value.Line, {
      style: {
        display: 'inline-flex',
        alignItems: 'center'
      },
      onClick: handle,
      children: [arrowView, (typeof keyName === 'string' || typeof keyName === 'number') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_semicolon.Semicolon, {
          value: value,
          quotes: quotes,
          render: components.objectKey,
          color: typeof keyName === 'number' ? _value.typeMap['number'].color : '',
          show: typeof keyName === 'string',
          children: keyName
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Colon, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Meta, {
        start: true,
        isArray: isArray,
        render: components.braces
      }), !expand && /*#__PURE__*/(0, _jsxRuntime.jsx)(Ellipsis, {
        render: components.ellipsis
      }), !expand && /*#__PURE__*/(0, _jsxRuntime.jsx)(Meta, {
        isArray: isArray,
        render: components.braces
      }), displayObjectSize && /*#__PURE__*/(0, _jsxRuntime.jsxs)(CountInfo, {
        children: [nameKeys.length, " items"]
      }), tools]
    }), expand && /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Line, {
      className: "w-rjv-content",
      style: {
        borderLeft: 'var(--w-rjv-border-left-width, 1px) solid var(--w-rjv-line-color, #ebebeb)',
        marginLeft: 6
      },
      children: entries.length > 0 && entries.map(function (_ref11, idx) {
        var _ref12 = (0, _slicedToArray2["default"])(_ref11, 2),
          key = _ref12[0],
          itemVal = _ref12[1];
        var item = itemVal;
        var renderKey = /*#__PURE__*/(0, _jsxRuntime.jsx)(_semicolon.Semicolon, {
          value: item,
          quotes: quotes,
          highlightUpdates: highlightUpdates,
          render: components.objectKey,
          color: typeof key === 'number' ? _value.typeMap['number'].color : '',
          show: typeof key === 'string',
          children: key
        });
        var isEmpty = Array.isArray(item) && item.length === 0 || (0, _typeof2["default"])(item) === 'object' && item && !(item instanceof Date) && Object.keys(item).length === 0;
        if (Array.isArray(item) && !isEmpty) {
          var label = isArray ? idx : key;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RooNode, (0, _objectSpread2["default"])({
              value: item,
              keyid: keyid + subkeyid + label,
              keyName: label
            }, subNodeProps))
          }, label + idx);
        }
        if ((0, _typeof2["default"])(item) === 'object' && item && !(item instanceof Date) && !isEmpty) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Line, {
            className: "w-rjv-wrap",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RooNode, (0, _objectSpread2["default"])({
              keyid: keyid + subkeyid + key,
              value: item,
              keyName: key
            }, subNodeProps))
          }, key + '' + idx);
        }
        if (typeof item === 'function') {
          return;
        }
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.ValueView, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, valueViewProps), {}, {
          renderKey: renderKey,
          keyName: key,
          value: item
        }), idx);
      })
    }), expand && /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Line, {
      style: {
        paddingLeft: 2
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Meta, {
        render: components.braces,
        isArray: isArray,
        style: {
          paddingLeft: 2,
          display: 'inline-block'
        }
      })
    })]
  }));
}